export default "__VITE_ASSET__DGeFYgXw__"